import { Type } from '@angular/core';

/**
 * Carrega a tela de login SOB DEMANDA, no gesto que a abre.
 *
 * POR QUÊ: o login é aberto como modal (`ModalPage` com `root: LoginPage`) a partir do cabeçalho
 * do cardápio, que é eager. O import estático da classe puxava `login.page` para o bundle do
 * boot e, pelo `login.module`, arrastava junto o cadastro e o "esqueci minha senha" — ~92 KB de
 * fonte que toda visita baixava antes de ver o cardápio, para uma tela que a maioria nunca abre.
 *
 * O módulo é carregado junto com a página DE PROPÓSITO: um componente só ganha o escopo do
 * template — as diretivas que ele usa — quando o arquivo do NgModule que o declara é avaliado
 * (`ɵɵsetNgModuleScope`). Trazer só a classe faria o modal abrir com o formulário sem validador
 * nem tradução, e em silêncio, porque `CUSTOM_ELEMENTS_SCHEMA` não reclama de diretiva ausente.
 * É a mesma armadilha que derrubou a tela de bordas em 17/09/2026 — ver `check:modal-tem-modulo`.
 *
 * FALHA DE REDE: devolve `null` em vez de estourar. O chamador cai para `navService.push('login')`,
 * que é o caminho de rota do mesmo chunk — com o retry de chunk do `main.ts` e a recuperação do
 * router por trás. Quem não conseguiu baixar o pedaço não pode ficar com um botão morto na mão.
 * A promessa memoizada é descartada no erro, para a próxima tentativa valer (a causa medida
 * destes chunks é rede lenta, que passa).
 */
export type CarregadorDeLogin = () => Promise<{ LoginPage: Type<any> }>;

const carregadorPadrao: CarregadorDeLogin = async () => {
	const [, pagina] = await Promise.all([
		import('../../pages/login/login.module'),
		import('../../pages/login/login.page'),
	]);
	return pagina;
};

let promessa: Promise<Type<any> | null> | null = null;

export function carregarTelaDeLogin(carregar: CarregadorDeLogin = carregadorPadrao): Promise<Type<any> | null> {
	if (!promessa) {
		promessa = carregar()
			.then((m) => m.LoginPage)
			.catch(() => {
				promessa = null;
				return null;
			});
	}
	return promessa;
}

/** Só para teste: apaga a memoização entre casos. */
export function esquecerTelaDeLogin(): void {
	promessa = null;
}
